import { useState } from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';
import ServitechLogo from './svg/servitech-logo.svg'
import { isLocal } from './appEnv';

import './styles.css'


// Local dev only: load reports as any userName instead of the username cookie
function UserNameInput(props) {
    const {
        handleFetchWithNewUserName,
        reportsQueryRequests
    } = props;

    const [newUserName, setNewUserName] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        handleFetchWithNewUserName(newUserName.trim());
    }

    return (
        <Form onSubmit={handleSubmit} className='d-flex' style={{ gap: "6px", marginTop: "4px", marginBottom: "4px" }}>
            <Form.Control
                type="text"
                size="sm"
                style={{ maxWidth: "200px" }}
                value={newUserName}
                placeholder={(reportsQueryRequests && reportsQueryRequests.userName) || "Enter userName"}
                onChange={(e) => { setNewUserName(e.target.value) }}
            />
            <Button type="submit" size="sm" style={{ whiteSpace: "nowrap" }} disabled={newUserName.trim() === ""}>
                Get Reports
            </Button>
        </Form>
    )
}

export default function TodoComponent(props) {
    const handleGoBack = () => {
        window.history.back();
    }

    return (
        <div className='header'>
            <Row className='row-header' style={{ padding: "0", margin: "0" }}>
                <Col xs={2} s={2} md={2} lg={2} xl={2}>
                    <img alt="ServiTech" className="logo" src={ServitechLogo} />
                </Col>
                <Col xs={{ span: 2, offset: 10 }} s={{ span: 2, offset: 10 }} md={{ span: 2, offset: 10 }} lg={{ span: 2, offset: 10 }} xl={{ span: 2, offset: 10 }}>
                    <Button onClick={handleGoBack} className='back-link'><b>Back</b></Button>
                </Col>
            </Row>
            <Row className='page-header' style={{ padding: "0", margin: "0", width: "100%", borderBottom: "1.5px solid gray" }}>
                {isLocal && props.handleFetchWithNewUserName &&
                    <Col xs="auto">
                        <UserNameInput {...props} />
                    </Col>
                }
                <Col >
                    <div className='d-none d-lg-block'>
                        <p style={{ marginBottom: "0" }}>Lab Reports</p>
                    </div>
                    <div className='d-lg-none'>
                        <p style={{ marginBottom: "0", fontSize: "18pt" }}>Lab Reports</p>
                    </div>
                </Col>
            </Row>
        </div>
    )
}
